import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { GlobalState } from 'ha/types/store';
import { FavoriteListing } from '@ha/api/v2/types/FavoriteListing';
import { FavoriteUnitType } from '@ha/api/v2/types/inventory/FavoriteUnitType';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import { getUserId, getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { Options } from '@ha/api/v2/getFavoriteListings';
import { Listing } from '@ha/api/v2/types/Listing';

import { isFetchStarted } from '../selectors';

export enum ActionTypes {
  START = '[favorites] LOAD_FAVORITES',
  DONE = '[favorites] LOAD_FAVORITES_DONE',
  FAIL = '[favorites] LOAD_FAVORITES_FAIL',
}
export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (favorites: FavoriteListing[]) =>
    createAction(ActionTypes.DONE, favorites),
  fail: () => createAction(ActionTypes.FAIL),
};
export type ActionsUnionType = ActionsUnion<typeof Actions>;
type FetchFavoriteListings = (
  isTenantMULFlowEnabled: boolean,
  options?: Options,
) => Thunk<GlobalState>;
export const getFavoriteListings: FetchFavoriteListings =
  (isTenantMULFlowEnabled, options) =>
  (dispatch, getState, { apiV2 }) => {
    const state = getState();

    if (!getIsAuthenticated(state)) {
      return Promise.resolve();
    }
    if (isFetchStarted(state)) {
      return Promise.resolve();
    }

    dispatch(Actions.start());

    const mulOptions: Options = { expand: '', withPhotos: false };
    if (options?.withPhotos) {
      mulOptions.expand = 'unit-type,photos';
    } else {
      mulOptions.expand = 'unit-type';
    }

    return (
      isTenantMULFlowEnabled
        ? apiV2.getFavoriteUnitTypes(getUserId(state)!, mulOptions)
        : apiV2.getFavoriteListings(getUserId(state)!, options)
    )
      .then(({ data }) => {
        let favorites: FavoriteListing[];
        if (isTenantMULFlowEnabled) {
          const unitTypeFavorites = data.favorites as FavoriteUnitType[];
          favorites = unitTypeFavorites.map(favorite => {
            const listing = {
              ...favorite.unitType,
              listingPath: favorite.unitType?.unitTypePath,
              unitTypeId: favorite.unitType?.id,
            } as Listing;

            return {
              ...favorite,
              listingId: favorite.unitTypeId || 0,
              listing,
            };
          });
        } else {
          favorites = data.favorites as FavoriteListing[];
        }

        dispatch(Actions.done(favorites));
      })
      .catch(error => {
        reportError('Error getting favourite listing', { metaData: { error } });
        dispatch(Actions.fail());
      });
  };
